"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const keysToCamelCaseDeep = (data) => Object.entries(data).reduce((acc, [key, value]) => {
    acc[lodash_1.camelCase(key)] = typeof value === 'object' && value !== null ? keysToCamelCaseDeep(value) : value;
    return acc;
}, Array.isArray(data) ? [] : {});
exports.default = keysToCamelCaseDeep;
//# sourceMappingURL=keys-to-camel-case-deep.js.map